export enum TradingStyle {
    day_trading = "Day trading",
    scalping = "Scalping",
}

export type TradingStyleValue = keyof typeof TradingStyle;
